// src/pages/hr/HROffboarding.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HROffboarding() {
  return (
    <HRComingSoon
      icon="🚪"
      title="Offboarding & Exit Management"
      description="Manage resignations, notice period tracking, exit clearance checklists, exit interviews, asset returns, and generate experience/relieving letters. Coming soon."
    />
  );
}
